<script setup lang="ts">
import { type PropType } from 'vue'
import ReverseSlider from '@/components/reverse-slider/ReverseSlider.vue'
import BaseButton from '@/components/ui/button/BaseButton.vue'
import type { Image, SliderSettings } from '@/types/ReverseSlider'

type SliderData = {
	title: string
	buttonText: string
	buttonLink: string
	imageList: Image[]
	secondImageList: Image[]
	sliderSettings: SliderSettings
}

const props = defineProps({
	reverseSliderData: {
		type: Object as PropType<SliderData>,
		required: true,
	},
})
</script>

<template>
	<section>
		<div class="flex flex-col gap-48px py-60px">
			<header class="flex flex-col items-center justify-center gap-20px">
				<h2 class="typography-h2-str text-n-950">
					{{ props.reverseSliderData.title }}
				</h2>
				<a :href="reverseSliderData.buttonLink">
					<BaseButton variant="secondary" size="medium">
						{{ props.reverseSliderData.buttonText }}
					</BaseButton>
				</a>
			</header>
			<main>
				<ReverseSlider
					:images="reverseSliderData.imageList"
					:secondImages="reverseSliderData.secondImageList"
					:settings="reverseSliderData.sliderSettings"
				/>
			</main>
		</div>
	</section>
</template>
